import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import CourseCard from "../../components/Course/CourseCard";
import CourseService from "../../service/courseService";
import courseBG from "../../assets/img/course/ed-bg-1.jpg";

const CourseOneMain = () => {
  const [searchParams] = useSearchParams();
  const levelId = searchParams.get("levelId");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError("");

    const request = levelId
      ? CourseService.listCoursesByAcademicLevel(levelId, { signal: controller.signal })
      : CourseService.getCourses({ signal: controller.signal });
    request
      .then((data) => {
        if (!controller.signal.aborted) setCourses(data);
      })
      .catch((error) => {
        if (!controller.signal.aborted) {
          setError(!error.response && error.code === "ERR_NETWORK"
            ? "Impossible de joindre le serveur. Veuillez réessayer."
            : error.response?.status === 401 || error.response?.status === 403
              ? "L’accès aux cours n’est pas encore public."
              : "Impossible de charger les cours. Veuillez réessayer.");
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, [attempt, levelId]);

  return (
    <main>
      <Breadcrumb title={levelId ? "Cours par niveau" : "Tous les cours"} subTitle="Cours" />
      <section
        id="it-course"
        className="it-course-area ed-course-bg ed-course-style-3 p-relative pt-120 pb-90"
        style={{ backgroundImage: `url(${courseBG})` }}
        aria-label="Liste des cours"
        aria-busy={loading}
      >
        <div className="container">
          <h2 className="mb-65">Découvrez nos cours</h2>
          {loading ? (
            <p role="status">Chargement des cours…</p>
          ) : error ? (
            <div>
              <p role="alert">{error}</p>
              <button className="ed-btn-theme" type="button" onClick={() => setAttempt((value) => value + 1)}>
                Réessayer
              </button>
            </div>
          ) : courses.length === 0 ? (
            <p role="status">Aucun cours disponible pour le moment.</p>
          ) : (
            <div className="row">
              {courses.map((course) => (
                <div key={course.id} className="col-xl-4 col-lg-6 col-md-6 mb-30">
                  <CourseCard course={course} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default CourseOneMain;
